// extracted by mini-css-extract-plugin
module.exports = {"root":"kNCzp","wrapper":"_2Rgxd","header":"_1p9No","title":"_1QHBr","subtitle":"_222WJ","items":"_17RKQ","item":"_24EqA"};